import React, { useMemo } from "react";
import Avatar from "./Avatar.jsx";
import { formatUserDisplayName, normalizeUser } from "../../utils/user.js";
import AppButton from "./AppButton.jsx";
import { useTheme } from "../../context/ThemeContext.jsx";
const VARIANT_MAP = isDark => ({
  badge: {
    wrapper: `inline-flex max-w-full items-center gap-1.5 rounded-full border px-1.5 py-0.5 ${"border-default bg-muted"}`,
    text: "text-[11px]",
    avatar: "sm"
  },
  compact: {
    wrapper: `inline-flex max-w-full items-center gap-1 rounded-full border px-1 py-0 ${"border-default bg-muted"}`,
    text: "text-[10px]",
    avatar: "xs"
  },
  table: {
    wrapper: "inline-flex max-w-full items-center gap-2",
    text: "text-sm",
    avatar: "sm"
  },
  header: {
    wrapper: "inline-flex max-w-full items-center gap-2.5",
    text: "text-sm",
    avatar: "md"
  }
});
export default function UserChip({
  user,
  size = "md",
  variant = "badge",
  showRole = false,
  showEmailInTooltip = true,
  className = "",
  clickable = false,
  onClick,
  title
}) {
    const normalized = useMemo(() => normalizeUser(user), [user]);
  const displayName = formatUserDisplayName(normalized || user || {}) || "Unbekannt";
  const roleText = normalized?.role != null ? String(normalized.role) : "";
  const tooltip = title || [displayName, showRole && roleText ? roleText : "", showEmailInTooltip ? normalized?.email || "" : ""].filter(Boolean).join(" · ");
  const variants = VARIANT_MAP(true);
  const variantConfig = variants[variant] || variants.badge;
  const avatarSize = size === "sm" ? "sm" : size === "md" ? "md" : variantConfig.avatar;
  const content = <span className={`${variantConfig.wrapper} ${variantConfig.text} ${className}`} title={tooltip || displayName}>
      <Avatar user={normalized || user} size={avatarSize} />
      <span className="min-w-0 flex-1 truncate font-medium text-primary">{displayName}</span>
      {showRole && roleText ? <span className="shrink-0 truncate text-[11px] text-muted">{roleText}</span> : null}
    </span>;
  if (clickable) {
    return <AppButton type="button" variant="ghost" onClick={onClick} className="inline-flex min-w-0 rounded focus:outline-none focus:ring-2 focus:ring-blue-400/40 !p-0 min-h-0" aria-label={`Profil von ${displayName} öffnen`}>
        {content}
      </AppButton>;
  }
  return content;
}